import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import axios from "axios";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Lock, Mail } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const LOGO_URL = "https://customer-assets.emergentagent.com/job_spark-showcase-2/artifacts/k5fdni51_INTERCHAMPION%20C.I.E.%20CHAMPION%20OF%20POLAND%20GRAND%20CHAMPION%20OF%20POLAND%20CHAMPION%20OF%20SLOVAKIA%20CHAMPION%20OF%20HUNGARY%20CHAMPION%20OF%20CZECH%20REP.%20VIT%27AZ%20SLOVENSK%C3%81%20GRAND%20CHAMPION%20OF%20SLOVAKIA%20GRAND%20CHAMPION%20OF%20HUNGA%2824%29.png";

const AdminLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      toast.error("Wypełnij wszystkie pola");
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(`${API}/admin/login`, { email, password });
      localStorage.setItem("adminToken", response.data.access_token);
      toast.success("Zalogowano pomyślnie");
      navigate("/admin");
    } catch (error) {
      toast.error("Nieprawidłowe dane logowania");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center p-4" data-testid="admin-login-page">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md"
      >
        <div className="bg-[#111] rounded-3xl p-8 border border-white/5">
          <div className="text-center mb-8">
            <img src={LOGO_URL} alt="ApisDesign" className="h-12 mx-auto mb-6" />
            <h1 className="text-2xl font-display font-bold text-white mb-2">Panel administracyjny</h1>
            <p className="text-white/50 text-sm">Zaloguj się, aby zarządzać treścią</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <Label htmlFor="email" className="text-white/70 mb-2 block">E-mail</Label>
              <div className="relative">
                <Mail className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-white/30" />
                <Input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="admin@apisdesign.online"
                  className="bg-white/5 border-white/10 text-white pl-12 h-12 rounded-xl focus:border-[#8B5CF6]"
                  data-testid="admin-email-input"
                />
              </div>
            </div>

            <div>
              <Label htmlFor="password" className="text-white/70 mb-2 block">Hasło</Label>
              <div className="relative">
                <Lock className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-white/30" />
                <Input
                  id="password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="••••••••"
                  className="bg-white/5 border-white/10 text-white pl-12 h-12 rounded-xl focus:border-[#8B5CF6]"
                  data-testid="admin-password-input"
                />
              </div>
            </div>

            <Button
              type="submit"
              disabled={loading}
              className="w-full bg-gradient-to-r from-[#8B5CF6] to-[#6D28D9] text-white h-12 rounded-xl"
              data-testid="admin-login-btn"
            >
              {loading ? (
                <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
              ) : (
                "Zaloguj się"
              )}
            </Button>
          </form>

          <p className="text-center text-white/30 text-xs mt-6">
            Domyślne dane: admin@apisdesign.online / Admin123!
          </p>
        </div>
      </motion.div>
    </div>
  );
};

export default AdminLogin;
